
import { Box, TextField, MenuItem, FormControl, InputLabel, Select, Typography, SvgIcon, Chip, FormControlLabel, Checkbox, Stack, Switch, Fade, List, ListItem, ListItemIcon, ListItemText, Card, CardContent, Avatar, Grid, Alert } from "@mui/material";


import NumbersIcon from '@mui/icons-material/Numbers';
import React, { useEffect, useState } from "react";
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { PAYMENT_METHODS_ICONS, RAFFLE_TYPE_ICONS } from "../../../../constants/icons";
import { PAYMENT_METHODS } from "../../../../constants/paymentMethods";
import { CreateStepperRaffleProps } from "../../../../domain/CreateStepperRaffleProps";
import { ICreationRaffle } from "../../../../store/interfaces/ICreationRaffle";
import { DatePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";
import CountdownTimer from "../../../common/Countdown";
import { BadgeCheck, Star, StarIcon } from "lucide-react";


interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const NumericFormatCustom = React.forwardRef<NumericFormatProps, CustomProps>(
  function NumericFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: Number.parseInt(values.value).toString(),
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
        prefix="$"
      />
    );
  },
);

export const MainFeaturesStep = ({resource, setResource, setDisableNext}: CreateStepperRaffleProps) => {

  const [mainFeaturesResource, setRaffleMainFeaturesResource] = useState<ICreationRaffle>(resource);
  const [hasLauchDate, setHasLauchDate] = useState<boolean>(false);
  const [isPremiumRaffle, setIsPremiumRaffle] = useState(false);
  const toggleIsPremiumRaffle = (check: boolean) => {
    setIsPremiumRaffle(check)
    setRaffleMainFeaturesResource((prevState) => ({ ...prevState, isPremium: check }));
  };

  const premiumFeatures = [
    "Todas lo de una rifa basica",
    "Retraso de números premiados",
    "Soporte vía WhatsApp + Auto revisión para los usuarios",
    "Todos los reportes habilitados: compradores, hora de compra, países de compra",
    "Promociones: envío a los mejores compradores de antiguas rifas",
  ];
 
  const basicFeatures = [
    "Gestion de ordenes de compra",
    "Visualizacion de números disponibles",
    "Reportes de ingresos separados por cuenta",
    "Reenvio de tickets a los compradores",
  ];


  useEffect(() => {
    setResource(mainFeaturesResource);
  }, [mainFeaturesResource, setResource])


  const handleChange = (event: any) => {
    let { name, value } = event.target;
    if (name === "ticketPrice" || name === "ticketPriceUSD" ) {
      setRaffleMainFeaturesResource((prevState) => ({ ...prevState, [name]: Number.parseInt(value) }));
      return
    }
    setRaffleMainFeaturesResource((prevState) => ({ ...prevState, [name]: value }));
  };


useEffect(() => {
  if (setDisableNext !== undefined) {
    setResource(mainFeaturesResource);
    const isFormValid =
      mainFeaturesResource.name.trim() !== "" &&
      mainFeaturesResource.ticketPrice > 0 &&
      mainFeaturesResource.limit > 0 &&
      mainFeaturesResource.type !== "" &&
      mainFeaturesResource.availablePaymentMethods.length > 0;
  
    setDisableNext(!isFormValid);
  }
}, [mainFeaturesResource, setResource, setDisableNext]);
  
const [launchDate, setLaunchDate] = useState<Dayjs | null>(null);
const [launchTime, setLaunchTime] = useState<Dayjs | null>(null);

const handleChangeHasReferenceNumber = (event: any) => {
  setRaffleMainFeaturesResource((prevState) => ({ ...prevState, hasReferenceNumber: event.target.checked }));
};

useEffect(() => {
  if (launchDate && launchTime) {
    const combinedDateTime = launchDate
      .hour(launchTime.hour())
      .minute(launchTime.minute())
      .second(0)
      .add(1, 'day');

    const epochTime = combinedDateTime.unix();

    setRaffleMainFeaturesResource((prevState) => ({ ...prevState, launchDate: epochTime }));
  }
}, [launchDate, launchTime]);

  return (
    <Box p={2}>
      <Box>
        <TextField
          required
          label="Name"
          variant="outlined"
          fullWidth
          name="name"
          value={mainFeaturesResource.name}
          onChange={handleChange}
          inputProps={{ maxLength: 48 }}
        />
      </Box>
      <Box mt={2}>
         <FormControl fullWidth>
          <TextField
            label="Precio del ticket"
            variant="outlined"
            required
            fullWidth
            name="ticketPrice"
            value={mainFeaturesResource.ticketPrice}
            onChange={handleChange}
            id="filled-adornment-amount"
            inputProps={{ maxLength: 7 }}
            InputProps={{
              inputComponent: NumericFormatCustom as any,
            }}
          />
        </FormControl>
      </Box>
      <Box mt={2}>
         <FormControl fullWidth>
          <TextField
            label="Precio del ticket en dólares"
            variant="outlined"
            required
            fullWidth
            name="ticketPriceUSD"
            value={mainFeaturesResource.ticketPriceUSD}
            onChange={handleChange}
            id="filled-adornment-amount"
            inputProps={{ maxLength: 7 }}
            InputProps={{
              inputComponent: NumericFormatCustom as any,
            }}
          />
        </FormControl>
      </Box>
      <Box mt={2}>
        <FormControl variant="outlined" fullWidth>
          <InputLabel>Tipo de concurso</InputLabel>
          <Select
            required
            label="Tipo de concurso"
            name="type"
            value={mainFeaturesResource.type}
            onChange={handleChange}
          >
            {RAFFLE_TYPE_ICONS.map((element) => (
              <MenuItem key={element.id} value={element.id}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {element.icon}
                  <Typography ml={1}>{element.name}</Typography>
                </div>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
       <Box mt={2}>
        <FormControl variant="outlined" fullWidth disabled={mainFeaturesResource.type === ''}>
          <InputLabel>Número de tickets</InputLabel>
          <Select
            required
            label="Número de tickets"
            name="limit"
            value={mainFeaturesResource.limit}
            onChange={handleChange}
            renderValue={(value) => {
              return (
                <Box sx={{ display: "flex", gap: 1 }}>
                  <SvgIcon color="primary">
                    <NumbersIcon />
                  </SvgIcon>
                  {`${value}`}
                </Box>
              );
            }}
          >
            <MenuItem value={100}>100</MenuItem>
            <MenuItem value={1000}>1000</MenuItem>
            <MenuItem value={10000}>10000</MenuItem>
            <MenuItem disabled={mainFeaturesResource.type !== 'promo'} value={100000}>100000</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Box mt={2}>
        <FormControlLabel control={<Checkbox
            checked={mainFeaturesResource.hasReferenceNumber}
            onChange={(event) => handleChangeHasReferenceNumber(event)}
          />} label="Validación número de referencia" />


          {mainFeaturesResource.hasReferenceNumber && <Alert severity="info">
            Las compras requerirán el numero de referencia
        </Alert>}
      
      </Box>
      <Box mt={2}>
        <FormControl variant="outlined" fullWidth>
          <InputLabel>Métodos de pago</InputLabel>
          <Select
            required
            multiple
            name="availablePaymentMethods"
            label="Métodos de pago"
            value={mainFeaturesResource.availablePaymentMethods}
            onChange={handleChange}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => (
                  <Chip variant="outlined" key={value} label={value}  icon={PAYMENT_METHODS_ICONS("20px").find((icon) => icon.id === value)?.icon} size="medium" />
                ))}
              </Box>
            )}
          >
            {PAYMENT_METHODS.map((element) => (
              <MenuItem key={element.id} value={element.id}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {PAYMENT_METHODS_ICONS("20px").find((icon) => icon.id === element.id)?.icon}
                  <Typography ml={1}>{element.name}</Typography>
                </div>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Box>
      <Box mt={2} display="flex" alignItems="center" justifyContent={"center"} gap={2} width={"100%"}>
        <Box display="flex">
          <Typography variant="h6" color="text.primary">
            Básica
          </Typography>
          <Switch
            checked={isPremiumRaffle}
            onChange={($event: any) => {
              toggleIsPremiumRaffle($event.target.checked)
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
          <Typography variant="h6" color="text.primary">
            Premium
          </Typography>
        </Box>
      </Box>
    </Box>

    <Grid container spacing={3} mt={3}>
  {/* Basic Features */}
  <Grid item xs={12} md={6}>
    <Fade in={!isPremiumRaffle} timeout={500}>
      <Box
        sx={{
          p: 3,
          borderRadius: 3,
          opacity: isPremiumRaffle ? 0.4 : 1,
          transition: "opacity 0.3s ease-in-out",
        }}
      >
        <Typography variant="h6" mb={1}>
          Rifa Básica
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={2}>
          Precio de mantención: <strong>$50 USD</strong>
        </Typography>
        <List dense>
          {basicFeatures.map((feature, index) => (
            <ListItem key={index} disablePadding sx={{ mb: 1 }}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <BadgeCheck color={isPremiumRaffle ? "gray" : "blue"} />
              </ListItemIcon>
              <ListItemText
                primary={feature}
                primaryTypographyProps={{
                  fontSize: "0.95rem",
                  color: isPremiumRaffle ? "text.disabled" : "text.primary",
                }}
              />
            </ListItem>
          ))}
        </List>
      </Box>
    </Fade>
  </Grid>

  {/* Premium Features */}
  <Grid item xs={12} md={6}>
    <Fade in={isPremiumRaffle} timeout={500}>
      <Box
        sx={{
          p: 3,
          borderRadius: 3,
          opacity: isPremiumRaffle ? 1 : 0.4,
          transition: "opacity 0.3s ease-in-out",
        }}
      >
        <Typography variant="h6" mb={1}>
          Rifa Premium
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={2}>
          Precio de mantención: {resource.accountId != 'oscar-alarcon' ? <strong>$250 USD</strong> : <strong>$150 USD</strong>}
        </Typography>
        <List dense>
          {premiumFeatures.map((feature, index) => (
            <ListItem key={index} disablePadding sx={{ mb: 1 }}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <BadgeCheck color={isPremiumRaffle ? "blue" : "gray"} />
              </ListItemIcon>
              <ListItemText
                primary={feature}
                primaryTypographyProps={{
                  fontSize: "0.95rem",
                  color: isPremiumRaffle ? "text.primary" : "text.disabled",
                }}
              />
            </ListItem>
          ))}
        </List>
      </Box>
    </Fade>
  </Grid>
</Grid>



      {/* <Box mt={2}>
        <FormControlLabel control={<Checkbox
            checked={hasLauchDate}
            onChange={(event) => setHasLauchDate(event.target.checked)}
          />} label="Tiene fecha de lanzamiento" />
      </Box> */}
      {
        hasLauchDate && <Box mt={2}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Stack direction={"column"} spacing={4}>
          <DatePicker
            label="Fecha de lanzamiento"
            value={launchDate}
            onChange={(newValue) => setLaunchDate(newValue)}
          />
          <TimePicker
            label="Hora de lanzamiento"
            value={launchTime}
            onChange={(newValue) => setLaunchTime(newValue)}
          />
          {
            hasLauchDate && mainFeaturesResource.launchDate && <CountdownTimer targetEpoch={mainFeaturesResource.launchDate}></CountdownTimer>
          }
          </Stack>
        </LocalizationProvider>
      </Box>
      }
      
    </Box>
  );
};
